import PropTypes from 'prop-types';

import { formatDisplayAmount } from '#/utils/formatNumber';

import CollectionSimpleTable from './CollectionSimpleTable';

const PHASE_COLUMNS = [
  { id: 'phaseNo', header: '期別', accessorKey: 'phaseNo', size: 70, enableSorting: false },
  {
    id: 'contractedAmount',
    header: '約定額',
    accessorFn: (row) => formatDisplayAmount(row.contractedAmount),
    size: 120,
    enableSorting: false,
    meta: { cellClassName: 'td_right' },
  },
  {
    id: 'creditedAmount',
    header: '已抵付',
    accessorFn: (row) => formatDisplayAmount(row.creditedAmount),
    size: 120,
    enableSorting: false,
    meta: { cellClassName: 'td_right' },
  },
];

function Stat({ label, value, hint }) {
  return (
    <div className="rounded border border-slate-200 px-3 py-2">
      <p className="text-xs text-slate-500">{label}</p>
      <p className="text-base font-medium text-slate-800">{formatDisplayAmount(value ?? 0)}</p>
      {hint ? <p className="text-xs text-slate-400">{hint}</p> : null}
    </div>
  );
}

Stat.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hint: PropTypes.string,
};

/** 收款彙總：只從已確認紀錄計算；草稿不計入。 */
const CollectionSummaryCard = ({ summary }) => {
  if (!summary) {
    return null;
  }
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-1 gap-2 px-4 pt-3 sm:grid-cols-3">
        <Stat label="已確認實收" value={summary.confirmedAmount} />
        <Stat label="已抵付期別" value={summary.allocatedAmount} />
        <Stat label="期別未抵付" value={summary.unallocatedAmount} hint="實收中尚未抵付到期別的金額" />
      </div>
      <CollectionSimpleTable
        rows={summary.phases ?? []}
        columns={PHASE_COLUMNS}
        emptyText="沒有期別資料"
        rowIdPrefix="summary-phase"
      />
    </div>
  );
};

CollectionSummaryCard.propTypes = {
  summary: PropTypes.shape({
    confirmedAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    allocatedAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unallocatedAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    phases: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default CollectionSummaryCard;
